import React, { useRef, useEffect } from 'react';
var VeltCommentDialogAssignDropdown = function (props) {
    var annotationId = props.annotationId, defaultCondition = props.defaultCondition, inlineCommentSectionMode = props.inlineCommentSectionMode, assignTo = props.assignTo, selectedUserContacts = props.selectedUserContacts, onSetAssignTo = props.onSetAssignTo, children = props.children;
    var ref = useRef(null);
    useEffect(function () {
        if (ref.current && onSetAssignTo) {
            var element_1 = ref.current;
            var handleSetAssignTo_1 = function (event) {
                onSetAssignTo(event.detail);
            };
            element_1.addEventListener('setAssignTo', handleSetAssignTo_1);
            return function () {
                element_1.removeEventListener('setAssignTo', handleSetAssignTo_1);
            };
        }
    }, [onSetAssignTo]);
    return (React.createElement("velt-comment-dialog-assign-dropdown", { ref: ref, "annotation-id": annotationId, "default-condition": [true, false].includes(defaultCondition) ? (defaultCondition ? 'true' : 'false') : undefined, "inline-comment-section-mode": [true, false].includes(inlineCommentSectionMode) ? (inlineCommentSectionMode ? 'true' : 'false') : undefined, "assign-to": assignTo ? (typeof assignTo === 'string' ? assignTo : JSON.stringify(assignTo)) : undefined, "selected-user-contacts": selectedUserContacts ? (typeof selectedUserContacts === 'string' ? selectedUserContacts : JSON.stringify(selectedUserContacts)) : undefined }, children));
};
export default VeltCommentDialogAssignDropdown;
